import { render, staticRenderFns } from "./ProductsChoices.vue?vue&type=template&id=272c218d&"
import script from "./ProductsChoices.vue?vue&type=script&lang=js&"
export * from "./ProductsChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports